import axios from 'axios'
import { errorHandler } from '@/api/error-handler'

const BASE_URL = '/activesubstances'

export default {
  count: () => axios.get(`${BASE_URL}/count`)
    .then(response => response.data)
    .catch(errorHandler),

  list: (params) => axios.get(`${BASE_URL}`, { params: params })
    .then(response => response.data)
    .catch(errorHandler),

  retrieve: (id) => axios.get(`${BASE_URL}/${id}`)
    .then(response => response.data)
    .catch(errorHandler),

  types: () => axios.get(`${BASE_URL}/types`)
    .then(response => response.data)
    .catch(errorHandler),

  subtypes: () => axios.get(`${BASE_URL}/subtypes?biocide`)
    .then(response => response.data)
    .catch(errorHandler),

  families: () => axios.get(`${BASE_URL}/families`)
    .then(response => response.data)
    .catch(errorHandler),
  
  activities: () => axios.get(`${BASE_URL}/activities`)
    .then(response => response.data)
    .catch(errorHandler),

  ractypes: () => axios.get(`${BASE_URL}/ractypes`)
    .then(response => response.data)
    .catch(errorHandler),

  insecticidePlantBehavior: () => axios.get(`${BASE_URL}/insecticide_plant_behavior`)
    .then(response => response.data)
    .catch(errorHandler),

  herbicideMigrationMode: () => axios.get(`${BASE_URL}/herbicide_migration_mode`)
    .then(response => response.data)
    .catch(errorHandler),

  cultivations: () => axios.get(`${BASE_URL}/cultivations`)
    .then(response => response.data)
    .catch(errorHandler),

  targets: () => axios.get(`${BASE_URL}/targets`)
    .then(response => response.data)
    .catch(errorHandler),

  classifications: () => axios.get(`${BASE_URL}/classifications`)
    .then(response => response.data)
    .catch(errorHandler)
}
